import styled from 'styled-components'

export const Row = styled.tr<{ selected?: boolean }>`
  border-bottom: 1px solid ${({ theme }) => theme.colors.backgroundLight};
  height: 45px;
  padding: 5px 10px;

  td:first-child {
    padding-left: 5px;
  }

  ${({ selected, theme }) => selected && `background: ${theme.colors.light};`}
`

export const Table = styled.table`
  border-collapse: collapse;
  color: ${({ theme }) => theme.colors.backgroundSecondary};
  font-size: 14px;
  font-weight: 500;
  width: 100%;

  tbody > ${Row}:hover {
    background: ${({ theme }) => theme.colors.light};
  }
`

export const Cell = styled.td<{ align?: string }>`
  overflow: hidden;
  padding: 5px 0;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ width }) =>
    width &&
    `width: ${width}px;
     max-width: ${width}px;
    `}

  ${({ align }) => align && `text-align: ${align}`}
`

export const Head = styled.thead`
  text-transform: uppercase;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.backgroundSecondary};
  border-spacing: 0;

  ${Row} {
    th:first-child {
      padding-left: 5px;
    }
  }
`
